export const NODE_WIDTH = 292;
export const Y_AXIS_SPACING = 60;
export const INTERFACE_FOCUSED_MODE_Y_AXIS_SPACING = 30;
export const CLIENT_NODE_Y_AXIS_SPACING = 10;
export const X_AXIS_SPACING = NODE_WIDTH / 4;
